import { Component, OnDestroy } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { HknTypeService } from '@backoffice/costing/util-api';
import { type HknIdentifier } from '@clean-code/models';
import { indicate } from '@clean-code/shared/common';
import { CanDeactivateForm } from '@clean-code/shared/components/ui-can-deactivate';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { filter, map, switchMap, takeUntil } from 'rxjs/operators';
import { HknIdentifierFormFacade } from '../../application/hkn-identifier-form.facade';

@Component({
  selector: 'backoffice-frontend-hkn-identifier-form',
  templateUrl: './hkn-identifier-form.component.html',
  standalone: false,
})
export class HknIdentifierFormComponent
  extends CanDeactivateForm<HknIdentifier>
  implements OnDestroy
{
  public navigationUrl = '/settings/hkn-identifier';

  public faTimes = faTimes;

  public hknTypes$ = this.hknTypeService.search$({});

  formGroup = new UntypedFormGroup({
    id: new UntypedFormControl(),
    identifier: new UntypedFormControl(null, [Validators.required]),
    year: new UntypedFormControl(null, [Validators.required]),
    hknTypeId: new UntypedFormControl(null, [Validators.required]),
    supplierId: new UntypedFormControl(null, [Validators.required]),
    deliveryAreaId: new UntypedFormControl(null, [Validators.required]),
  });

  constructor(
    private hknTypeService: HknTypeService,
    hknIdentifierService: HknIdentifierFormFacade,
  ) {
    super(hknIdentifierService);
  }

  public suppliers$ = this.formGroup.controls.hknTypeId.valueChanges.pipe(
    filter((hknTypeId) => !!hknTypeId),
    switchMap((hknTypeId) => {
      return this.hknTypeService
        .getSuppliersByHknTypeId$(hknTypeId)
        .pipe(map((suppliers) => suppliers.items));
    }),
    takeUntil(this.closeSubject),
  );

  public deliveryAreas$ = this.formGroup.controls.hknTypeId.valueChanges.pipe(
    filter((hknTypeId) => !!hknTypeId),
    switchMap((hknTypeId) => {
      return this.hknTypeService
        .getDeliveryAreasByHknTypeId$(hknTypeId)
        .pipe(map((suppliers) => suppliers.items));
    }),
    takeUntil(this.closeSubject),
  );

  public override delete() {
    this.service
      .delete$(this.formGroup.controls.id.value)
      .pipe(indicate(this.isLoading$), takeUntil(this.closeSubject))
      .subscribe(() => {
        this.toastService.showSuccess('common.SUCCESSFULLY_DELETED');
        this.tableStateService?.refresh();
        void this.router.navigate(['../../'], {
          relativeTo: this.activatedRoute,
        });
      });
  }
}
